export default __webpack_public_path__ + "static/media/kitchen1-480w.b24a7d80.png";